import classnames from 'classnames';
import React, { FC } from 'react';
import { ExternalSource } from '../../../../constants/Source';
import { ComputerImporter } from '../ComputerImporter';
import { FilesViewer } from '../FilesViewer';
import { UrlImporter } from '../UrlImporter';
import styles from './Content.scss';
import { IOuter } from './Content.types';

export const Content: FC<IOuter> = ({
  source,
  isConnected,
  openedFrom,
  onConnectClicked,
  onSourceSessionExpired,
  onSelect,
  className,
  connectorsMap,
  folderPath,
}) => (
  <div className={styles.wrapper}>
    {source === ExternalSource.Link ? (
      <UrlImporter openedFrom={openedFrom} onSelect={onSelect} />
    ) : source === ExternalSource.Computer ? (
      <ComputerImporter onSelect={onSelect} />
    ) : (
      /**
       * We need `key` prop to instantiate FilesViewer every time `sourceName` is changed to reset its internal state.
       * Otherwise it can have `currentFolder` prop which will make load files for a folder which exists in another source
       */
      <FilesViewer
        folderPath={folderPath}
        openedFrom={openedFrom}
        key={source}
        className={classnames(styles.content, className)}
        source={source}
        isConnected={isConnected}
        onConnectClicked={onConnectClicked}
        onSourceSessionExpired={onSourceSessionExpired}
        onSelect={onSelect}
        connectorsMap={connectorsMap}
      />
    )}
  </div>
);
